import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Conversion } from '@/components/pages/edit-campaign/form-elements/conversion';
import { Cpa } from '@/components/pages/edit-campaign/form-elements/cpa';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

export function JoveoForm() {
  const intl = useIntl();
  const { hookForm, campaign, isCompleted } = useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;
  const { control } = hookForm;
  const budgetTypeOptions = useBudgetTypeOptions();

  return (
    <>
      <Dates campaignStartsAt={campaign?.starts_at} />

      <div className="flex flex-col gap-2">
        <Budget label={intl.formatMessage({ defaultMessage: 'Spend' })} />
        <Controller
          control={control}
          name="budget_type"
          render={({ field }) => (
            <RadioGroup
              onValueChange={field.onChange}
              value={field.value}
              className="my-2 flex justify-between gap-4"
              disabled={isCompleted || isReadonly}
            >
              {budgetTypeOptions.map(option => (
                <div
                  key={option.value}
                  className="flex items-center space-x-2 whitespace-nowrap"
                >
                  <RadioGroupItem value={option.value} id={option.value} />
                  <Label htmlFor={option.value}>{option.label}</Label>
                </div>
              ))}
            </RadioGroup>
          )}
        />
      </div>

      <TargetBudget
        budgetSpent={campaign?.budget_spent ?? 0}
        hideTargetBudget={isCompleted}
      />
      <Cpa />
      <Conversion />
    </>
  );
}

function useBudgetTypeOptions() {
  const intl = useIntl();

  return [
    {
      value: 'lifetime',
      label: intl.formatMessage({ defaultMessage: 'Total Budget' }),
    },
    {
      value: 'daily',
      label: intl.formatMessage({ defaultMessage: 'Per day' }),
    },
    {
      value: 'weekly',
      label: intl.formatMessage({ defaultMessage: 'Per week' }),
    },
    {
      value: 'monthly',
      label: 'Per month',
    },
  ];
}
